<div class="emds">
  <div class="modal-default"
       id="{{Id}}">

    <div class="modal-header">
      <span translate>{{title}}</span>
    </div>

    <div class="modal-body">

      <div *ngIf="showWarning()">
        <span id="ap-editor-warning"
              class="ap-macro-editor-warning alert alert-warning alert-dismissible"
              role="alert">
          <span class="ap-editor-warning-text"
                [innerHTML]="warningText"></span>
          <div id="ap-macro-editor-warning-close-x"
               class="close"
               (click)="closeWarning()">&times;</div>
        </span>
      </div>

      <ap-macro-editor #macroEditor
                       [baseId]="Id"
                       [macroService]="macroService"
                       [macroDefinitionDto]="originalMacroDefinitionDtoValue"
                       [macroInterfaces]="macroInterfaces"
                       [defaultMacroGroup]="defaultMacroGroup">
      </ap-macro-editor>
    </div>
    <div class="modal-footer">
      <button id="{{Id}}-cancel"
              class="btn btn-secondary pull-right btn-flush-right"
              (click)="dismissModal()"
              translate>Cancel</button>
      <button form="macro-editor-form"
              id="{{Id}}-save"
              class="btn btn-primary pull-right"
              (click)="close()"
              translate>Save</button>
    </div>
  </div>
</div>
